import Sidebar from "../../../components/Sidebar";

export default function Dashboard() {
  return (
    <>
      <Sidebar />

      <main className="dashboard-content">
        <h1>👋 مرحبًا بك في لوحة التحكم</h1>
        <p>اختر من القائمة الجانبية.</p>
      </main>

      <style>{`
.dashboard-content{
    min-height:100vh;
    margin-right:312px;
    padding:40px;
    background:#f5f7fb;
    direction:rtl;
    transition:all .3s ease;
}

.dashboard-content h1{
    font-size:32px;
    color:#065f46;
    margin-bottom:10px;
}

.dashboard-content p{
    color:#6b7280;
    font-size:18px;
    line-height:1.7;
}

/* Tablet */
@media (max-width:992px){

.dashboard-content{
    margin-right:280px;
    padding:30px;
}

.dashboard-content h1{
    font-size:28px;
}

}

/* Mobile */
@media (max-width:768px){

.dashboard-content{
    margin-right:0;
    padding:80px 20px 20px;
}

.dashboard-content h1{
    font-size:26px;
}

.dashboard-content p{
    font-size:16px;
}

}

/* Small Phones */
@media (max-width:480px){

.dashboard-content{
    padding:75px 15px 15px;
}

.dashboard-content h1{
    font-size:22px;
}

.dashboard-content p{
    font-size:15px;
}

}
`}</style>
    </>
  );
}
